import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AppAuthService } from '../pages/Shared/_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ForcePasswordChangeGuard implements CanActivate {
  constructor(
    private authService: AppAuthService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Check if user is authenticated
    if (!this.authService.loggedIn()) {
      return this.router.createUrlTree(['/auth/login']);
    }

    // Check if force password change is required using user property
    const isForcePasswordChangeRequired = this.authService.currentUser?.forcePasswordChange === true;

    // Get the current route path
    const currentPath = state.url;

    // If force password change is required
    if (isForcePasswordChangeRequired) {
      // Only allow access to the force-change-password route
      if (currentPath === '/auth/force-change-password') {
        return true;
      }

      // Redirect all other routes to force-change-password
      return this.router.createUrlTree(['/auth/force-change-password']);
    }

    // If force password change is not required, allow access to all routes
    return true;
  }
}